module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("Without the inspiration of Jack Vance, Hayao Miyazaki,"), _c('br'), _vm._v("and Talbot Mundy, there would be no book.")]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_vm._v("Without the able and expert assistance of Chris Cornuelle,"), _c('br'), _vm._v("Chris Weuve, Martin Helsdon, Loma Griffith, Teresita Flores,"), _c('br'), _vm._v("and Suzanne MacDhomhail, the story would be far poorer.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36568726","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter002.vue
// module id = 75
// module chunks = 0